import type { FC } from 'react';
import type { ClientsEntity } from '../../../@types/gql/home';
import Image from '../../shared/image';
import InfiniteCarousel from '../../shared/infinite-scroll';
import OpacitySlideIn from '../../animation/opacity-slide-in';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const HomeBrandsSection: FC<{ clients: ClientsEntity[] }> = ({ clients }) => {
  const settings = {
    dots: false,
    infinite: true,
    loop:true,
    speed: 1000,
    slidesToShow: 8,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: true,
    autoplaySpeed: 1000,
    autoplay: true,
    cssEase: 'linear',
    draggable: false,
    swipeToSlide: false,
    touchMove: false,
    pauseOnFocus: true,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: true,
          autoplaySpeed: 4000,
          autoplay: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 0,
          arrows: true,
          autoplay: true,
          speed: 500,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          autoplay: false,
          speed: 500,
        },
      },
    ],
  };
  return (
    <section className="bg-[#F3F3F3] py-10 border-t">
      <OpacitySlideIn slideFrom={{ x: 0, y: 10 }}>
        <h2 className="text-4xl py-4 font-bold text-center whitespace-pre-wrap max-lg:text-2xl">
          Our Clients
        </h2>
      </OpacitySlideIn>
      <div className="flex flex-col gap-30 mx-auto brandContainer ">
        <Slider {...settings}>
          {clients.map(({ id, url }) => (
            <Image
              alt="..."
              className="h-24 w-full object-contain rounded-md"
              containerStyle={{ width: 170, height: 120, background: 'white' }}
              key={id}
              src={url}
            />
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default HomeBrandsSection;
